import { AppSettings } from './app.settings';
export class MapSetting {
    public static MAP_ENDPOINT =  `${AppSettings.BASE_URL}/api/product/map/:id`;
} 